import { Waitlist } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

import mesaValley from '@/assets/mesa-valley.webp';

export const Route = createFileRoute('/waitlist')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div
      className="flex h-screen w-screen justify-center items-center bg-amber-50"
      style={{
        backgroundImage: `url('${mesaValley}')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundColor: '#000',
      }}
    >
      <Waitlist signInUrl="/sign-in" />
    </div>
  );
}
